import { lazy } from 'react';

// project-imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

// render - login
const CustomerFeedback = Loadable(lazy(() => import('pages/project/job/feedback/customer-feedback')));


// ==============================|| AUTH ROUTES ||============================== //

const ProjectFeedbackRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <GuestGuard>
          <CommonLayout />
        </GuestGuard>
      ),
      children: [
        {
          path: '/feedback/:data',
          element: <CustomerFeedback />
        },
      
      ]
    }
  ]
};

export default ProjectFeedbackRoutes;
